import { AxiosError } from 'axios';
import api from '../api/api';
import useStore from '../store/store';

interface UpdateTrfFileParams {
    kitId: number;
    trf: File;
}

const UpdateTrfFile = async (params: UpdateTrfFileParams) => {
    const { setFormError, setIsLoading } = useStore.getState();

    setIsLoading(true);
    try {
        const formData = new FormData();
        formData.append('kitId', params.kitId.toString());
        formData.append('trf', params.trf);

        const response = await api.post('/kit/update-trf-file', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        const { success, errCode } = response.data;
        if (success) {
            setFormError('');
        } else if (errCode) {
            setFormError(errCode);
        } else {
            setFormError('other');
        }
    } catch (e: unknown) {
        if (e instanceof AxiosError) {
            console.error(e.response?.data);
            setFormError('');
            setTimeout(() => setFormError(e.code ?? 'other'), 0);
        } else {
            setFormError('');
            setTimeout(() => setFormError('other'), 0);
        }
    } finally {
        setIsLoading(false);
    }
};

export default UpdateTrfFile;
